// extracted by mini-css-extract-plugin
export default {"container":"hY-z","title":"iY-z","link":"jY-z"};